module.exports = __webpack_public_path__ + "img/ic-edit-grey.070ce549.svg";